/* eslint-disable no-color-literals */
import type { MetabaseThemeV2 } from "../../types";
import { LIGHT_THEME_ACCENT_COLORS } from "../accent-colors";
import { getBaseColorsForThemeDefinitionOnly } from "../base-colors";

const baseColors = getBaseColorsForThemeDefinitionOnly();

/**
 * The default light theme for Metabase.
 */
export const METABASE_LIGHT_THEME: MetabaseThemeV2 = {
  version: 2,
  chartColors: LIGHT_THEME_ACCENT_COLORS,
  colors: {
    "admin-navbar": baseColors.octopus[60],
    "admin-navbar-secondary": baseColors.octopus[40],
    "admin-navbar-inverse": baseColors.octopus[80],
    "background-brand": baseColors.brand[10],
    "background-disabled": baseColors.orionAlpha[10],
    "background-disabled-inverse": baseColors.orionAlphaInverse[10],
    "background-error-secondary": baseColors.lobster[5],
    "background-hover":
      "color-mix(in srgb, var(--mb-color-brand) 21%, transparent)",
    "background-hover-light":
      "color-mix(in srgb, var(--mb-color-brand) 7%, transparent)",
    "background-selected": baseColors.brand[50],
    "background-primary": baseColors.white,
    "background-secondary": baseColors.orion[5],
    "background-tertiary": baseColors.orion[10],
    "background-primary-inverse": baseColors.orion[80],
    "background-secondary-inverse": baseColors.orion[70],
    "background-tertiary-inverse": baseColors.orion[40],
    overlay: baseColors.orionAlpha[60],
    "bg-ocean-alpha-light": baseColors.oceanAlpha[5],
    "background-error": baseColors.lobster[10],
    "background-success": baseColors.palm[5],
    "brand-alpha-04":
      "color-mix(in srgb, var(--mb-color-brand) 4%, transparent)",
    "brand-alpha-88":
      "color-mix(in srgb, var(--mb-color-brand) 88%, transparent)",
    "brand-dark": baseColors.brand[60],
    "brand-darker": baseColors.brand[70],
    "brand-light": baseColors.brand[10],
    "brand-lighter": baseColors.brand[5],
    brand: baseColors.blue[40],
    danger: baseColors.lobster[50],
    error: baseColors.lobster[50],
    filter: baseColors.octopus[50],
    focus: baseColors.blue[20],
    "icon-primary": baseColors.brand[40],
    "icon-disabled": baseColors.orionAlpha[30],
    "icon-secondary": baseColors.orionAlpha[50],
    "metabase-brand": baseColors.blue[40],
    "saturated-blue": baseColors.ocean[60],
    "saturated-green": baseColors.palm[60],
    "saturated-purple": baseColors.octopus[60],
    "saturated-red": baseColors.lobster[60],
    "saturated-yellow": baseColors.dubloon[30],
    shadow: baseColors.orionAlpha[20],
    "success-secondary": baseColors.palm[60],
    success: baseColors.palm[50],
    summarize: baseColors.palm[50],
    "switch-off": baseColors.orionAlpha[20],
    "syntax-parameters-active": baseColors.mango[10],
    "syntax-parameters": baseColors.mango[60],
    "text-brand": baseColors.brand[50],
    "text-tertiary": baseColors.orionAlpha[40],
    "text-tertiary-inverse": baseColors.orionAlphaInverse[40],
    "text-hover": baseColors.brand[60],
    "text-secondary-opaque": baseColors.orion[60],
    "text-primary": baseColors.orionAlpha[80],
    "text-primary-inverse": baseColors.orionAlphaInverse[80],
    "text-secondary": baseColors.orionAlpha[60],
    "text-secondary-inverse": baseColors.orionAlphaInverse[60],
    "text-selected": baseColors.white,
    "tooltip-background-focused": `color-mix(in srgb, ${baseColors.orion[80]} 50%, #000)`,
    "tooltip-background": baseColors.orion[80],
    "tooltip-text-secondary": baseColors.orionAlphaInverse[60],
    "tooltip-text": baseColors.white,
    warning: baseColors.dubloon[30],
    "background-warning": baseColors.dubloon[5],
    info: baseColors.orion[40],
    "background-info": baseColors.orion[10],
    white: baseColors.white,
    border: baseColors.orion[20],
    "border-strong": baseColors.orionAlpha[50],
    "border-subtle": baseColors.orionAlpha[10],
    copper: "#B87333",
    bronze: "#CD7F32",
    silver: "#C0C0C0",
    gold: "#FFD700",
  },
};
